(function(window) {
  function toggleDropdown(e) {
    const _d = $(e.target).closest('.dropdown');
    const _m = $('.dropdown-menu', _d);
    setTimeout(
      function() {
        const shouldOpen = e.type !== 'click' && _d.is(':hover');
        _m.toggleClass('show', shouldOpen);
        _d.toggleClass('show', shouldOpen);
        $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
      },
      e.type === 'mouseleave' ? 50 : 0,
    );
  }

  $(document).ready(function() {
    $('[data-navigate-url]').on('click', function() {
      window.location.href = $(this).data('navigate-url');
    });

    $('.dialog-share').click(function(e) {
      e.preventDefault();
      window.open(
        $(this).attr('href'),
        'fbShareWindow',
        'height=450, width=550, top=' +
        ($(window).height() / 2 - 275) +
        ', left=' +
        ($(window).width() / 2 - 225) +
        ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0',
      );
      return false;
    });

    // $('.text-dotdotdot').dotdotdot({});

    $('.scroll-to').on('click', function() {
      $.scrollTo($(this).attr('data-navigate-section'), 800, { offset: -80 });
    });

    $('.show-search').on('click', function() {
      $('.search-sticky').addClass('sticky');
      $('.search-sticky .search-bar input[name="query"]').focus();

      return false;
    });

    $('.search-sticky .search-bar input[name="query"]').on('blur', function() {
      $('.search-sticky').removeClass('sticky');
      $('.typeahead').typeahead('val', '');
    });

    $(document).on('pjax:start', function() { NProgress.start(); });
    $(document).on('pjax:end',   function() { NProgress.done();  });

    $(document).on('pjax:timeout', function(event) {
      console.info('pjax timeout');
      // Prevent default timeout redirection behavior
      event.preventDefault()
    });

    $(document).on('pjax:error', function(event, xhr, textStatus, errorThrown, options) {
      console.info(options, 'options');
      console.info(errorThrown, 'errorThrown');
      console.info(textStatus, 'textStatus');
      console.info(xhr, 'xhr');
      return false;
    });

    $(document).pjax('[data-pjax] a, a[data-pjax]', '#content', {
      push: true,
      scrollTo: true,
    });

    $(document).on('submit', 'form[data-pjax]', function(event) {
      $.pjax.submit(event, '#content', {
        scrollTo: true,
      });
    });

    $.pjax.defaults.maxCacheLength = 0;

    // navbar dropdown on hover
    $('body')
      .on('mouseenter mouseleave', '.dropdown', toggleDropdown)
      .on('click', '.dropdown-menu a', toggleDropdown);

    // if ($('.grid-masonry').length) {
    // $('.grid-masonry').isotope({
    //   // options
    //   itemSelector: '.grid-item',
    //   layoutMode: 'fitRows'
    // });

    /* var elem = document.querySelector('.grid-masonry');
      var iso = new Isotope( elem, {
        // options
        itemSelector: '.grid-item',
        // layoutMode: 'masonryHorizontal',
        // percentPosition: true,
        // masonry: {
        //   // use element for option
        //   columnWidth: '.grid-sizer'
        // }
        // masonryHorizontal: {
        //   rowHeight: 50
        // },
        layoutMode: 'fitRows',
        percentPosition: true,
        masonry: {
          columnWith: '.grid-sizer'
        }
      });*/

    // }

    // $('.text-dotdotdot').each(function (i, el) {
    //   new Dotdotdot(el, {});
    // });

    // dot.API.truncate();
    // dot.API.watch();

    $('#container').on('click', 'a[data-href]', function (e) {
      e.preventDefault();

      ajaxFormRequest({
        url: $(this).data('href'),
        target: $(this).data('target')
      });
    });

    $('#container').on('click', 'a.record-remove', function() {
      var anchor = $(this);
      var row = $(this).parents('tr');

      bootbox.dialog({
        message: 'You <span class="text-danger"">cannot</span> recover deleted record. Are you sure to continue?',
        title: "Delete record",
        buttons: {
          cancel: {
            label: "Cancel",
            className: "btn-default"
          },
          main: {
            label: "Delete",
            className: "btn-danger",
            callback: function() {
              $.ajax({
                url: anchor.attr('href'),
                type:"GET",//request is a POSt request
                dataType: "json",//expect json as return
                beforeSend: function(jqXHR, settings){
                  anchor.hide();
                  anchor.parents('li:first').append('<a class="btn"><i class="inline-loading" style="padding-left: 12px;"></i></a>');
                },
                success: function(result) //trigger this on success
                {
                  anchor.parents('li:first').find('span.inline-loading').remove();

                  if(result.success != null && !result.success){
                    bootbox.dialog({
                      message: result.html,
                      title: "Error while deleting record",
                      buttons: {
                        main: {
                          label: "OK",
                          className: "btn-primary",
                          callback: function() {

                          }
                        }
                      }
                    });

                    anchor.show();
                  }
                  else
                  {
                    row.hide('slow');

                    var $count = row.parents('table:first').siblings('div.pagination-container').find('.pagination_desc strong.total-count');

                    $count.html(parseInt($count.text())-1);

                    if(result.message != null  && result.message.length > 0)
                    {
                      $(result.message).hide().insertBefore('div.control-container').fadeIn();

                      // setTimeout(function(){
                      // $('#flashnotice-container').fadeOut('slow', function(){
                      // $(this).remove();
                      // })
                      // }, 1000);
                    }
                  }
                }
              });
            }
          }
        }
      });

      return false;
    });
  });
})(window);
